import Sync from '@/views/syncdatetime/Index'
import { noAuthRoute } from '@/router/guards/auth'

export default {
  path: '/syncdatetime',
  name: 'syncdatetime',
  component: Sync,
  meta: {
    noAuth: true
  },

  beforeEnter (to, from, next) {
    const canEnter = noAuthRoute()

    if (canEnter) {
      return next(true)
    }
    
    next('/main')
  }
}